import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismButton } from '@mylighthouse/prism-ember';

interface HotelBenchmarkInsightGridExpandableGridExpandableItemButtonSignature {
  Args: {
    isExpanded?: boolean;
    onClick: () => void;
  };
}

const HotelBenchmarkInsightGridExpandableGridExpandableItemButton = <template>
  <PrismButton
    @buttonType="ghost"
    @icon={{if @isExpanded "collapse" "expand"}}
    @size="medium"
    data-test-id="grid-expandable-item-button"
    {{on "click" @onClick}}
  />
</template> satisfies TOC<HotelBenchmarkInsightGridExpandableGridExpandableItemButtonSignature>;

export default HotelBenchmarkInsightGridExpandableGridExpandableItemButton;
